import { useMutation, useQuery } from 'react-query';
import { settingsApi } from '../services/axios/api/settingsApi';

export function useInventorySettings() {
  return useQuery(['inventory-settings'], settingsApi.fetchInventorySettings, {
    retry: 0,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
}

export function useSaveInventorySettings() {
  return useMutation(settingsApi.postInventorySettings);
}
